module.exports = __webpack_public_path__ + "static/media/img_jerusalen.49da2283.jpg";